const form = {
  formId: "new-user-form",
  formField: {
    taxId: {
      name: "taxId",
      label: "1.Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label: "2.Tên tổ chức cá nhân",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức cá nhân:",
      invalidMsg: "tên tổ chức cá nhân không hợp lệ",
    },
    date: {
      name: "Date",
      label: "3.Ngày đã có thông báo phát hành hóa đơn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Ngày đã có thông báo phát hành hóa đơn",
      invalidMsg: "tên tổ chức cá nhân không hợp lệ",
    },
    agencyName: {
      name: "agencyName",
      label: "Tên đơn vị",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên đơn vị:",
      invalidMsg: "Tên đơn vị không hợp lệ",
    },
    agencyTax: {
      name: "agencyTax",
      label: "Mã số thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế:",
      invalidMsg: "Tên đơn vị không hợp lệ",
    },
    sendTo: {
      name: "sendTo",
      label: "Tên cơ quan thuế tiếp nhận thông báo",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên cơ quan tiếp nhận thông báo:",
      invalidMsg: "Tên đơn vị không hợp lệ",
    },

    releaseDate: {
      name: "releaseDate",
      label: "Ngày Lập báo cáo",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày lập báo cáo",
    },
    representative: {
      name: "representative",
      label: "Người đại diện theo pháp luật",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người đại diện",
    },
  },
};

export default form;
